import { renderWithLineBreaks } from 'utils/renderWithLineBreaks';

const PresentationInNr = ({ data }) => {
  return (
    <div className='full-pager flex flex-column sizes-section'>
      <div className='flex percentage-1'>
        <p className='font-size-60 img-page-font-grotesk'>
          {data?.section1?.number} <br />
          <span className='font-secondary font-size-30'>
            {renderWithLineBreaks(data?.section1?.title)}
          </span>
        </p>
        <p className='font-size-18'>{data?.section1?.description}</p>
      </div>
      <div className='flex percentage-2'>
        <p className='font-size-60 img-page-font-grotesk'>
          {data?.section2?.number}
          <br />
          <span className='font-secondary font-size-30'>
            {renderWithLineBreaks(data?.section2?.title)}
          </span>
        </p>
        <p className='font-size-18'>{data?.section2?.description}</p>
      </div>
      <div className='flex percentage-3'>
        <p className='font-size-60 img-page-font-grotesk'>
          {data?.section3?.number}
          <br />
          <span className='font-secondary font-size-30'>
            {renderWithLineBreaks(data?.section3?.title)}
          </span>
        </p>
        <p className='font-size-18'>{data?.section3?.description}</p>
      </div>
      <div className='flex percentage-4'>
        <p className='font-size-60 img-page-font-grotesk'>
          {data?.section4?.number}
          <br />
          <span className='font-secondary font-size-30'>
            {renderWithLineBreaks(data?.section4?.title)}
          </span>
        </p>
        <p className='font-size-18'>{data?.section4?.description}</p>
      </div>
    </div>
  );
};

export default PresentationInNr;
